import { DocsAction } from '../actionTypes';
import { DocsState } from '../reducer';

export type DocsLocalStorageState = Pick<
  DocsState,
  | 'goSdkGeneration'
  | 'androidLanguage'
  | 'apiVersion'
  | 'checklists'
  | 'clientPlatform'
  | 'iOSLanguage'
  | 'serverCodeLanguage'
  | 'dismissedBannerIds'
  | 'history'
  | 'codeBlockTheme'
>;

// List of actions on which to sync localStorage
export const LOCALSTORAGE_ALLOWLIST: Array<DocsAction['type']> = [
  'SET_GO_SDK_GENERATION',
  'SET_API_VERSION',
  'SET_CODE_LANGUAGE',
  'SET_INITIAL_STATE',
  'SET_IOS_LANGUAGE',
  'SET_ANDROID_LANGUAGE',
  'SET_CLIENT_PLATFORM',
  'SET_CODE_BLOCK_THEME',
  'ADD_CHECKLIST',
  'REMOVE_CHECKLIST',
  'DISMISS_BANNER',
];

const localStorageMiddleware = (action: DocsAction, state: DocsState) => {
  if (!LOCALSTORAGE_ALLOWLIST.includes(action.type)) {
    return;
  }

  const sanitizedState: DocsLocalStorageState = {
    goSdkGeneration: state.goSdkGeneration,
    androidLanguage: state.androidLanguage,
    apiVersion: state.apiVersion,
    checklists: state.checklists,
    clientPlatform: state.clientPlatform,
    iOSLanguage: state.iOSLanguage,
    serverCodeLanguage: state.serverCodeLanguage,
    history: state.history,
    dismissedBannerIds: state.dismissedBannerIds,
    codeBlockTheme: state.codeBlockTheme,
  };
  try {
    localStorage.setItem('PLAID_DOCS_STATE', JSON.stringify(sanitizedState));
  } catch {
    // Docs preferences still work when browser storage is disabled or full.
  }
};

export default localStorageMiddleware;
